import { useEffect, useState } from 'react';
import { Form, Input, Select, Alert, Button, Layout, Typography, Checkbox, Space, Divider, Radio, Modal, message, Steps, Row, Col, Spin } from 'antd';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import './index.less';
import { orgTypeList } from '@/utils/constants';
import { organizationsListApi, mergeOrganizationsApi } from '@/services/DC/Organization';
import ViewOrgDrawer from '../components/ViewOrgDrawer';
import { logOrganizationMerge } from '@/utils/organizationLogger';
import { ReviewStatusMap } from '@/utils/utils';
import PageHeader from '@components/PageHeader/PageHeader';
const { Text } = Typography;

// 合并机构
const OrganizationMerge = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [form] = Form.useForm();

    const [checkedList, setCheckedList] = useState([]);

    const [indeterminate, setIndeterminate] = useState(false);
    const [checkAll, setCheckAll] = useState(false);
    const [value, setValue] = useState();
    const [searchHospitalList, setSearchHospitalList] = useState([]);
    const [currentStep, setCurrentStep] = useState(0); // 当前步骤
    const [hasSearched, setHasSearched] = useState(false); // 是否已执行过检索

    // 查看机构相关状态
    const [openViewOrgDrawer, setOpenViewOrgDrawer] = useState(false);
    const [currentRecordId, setCurrentRecordId] = useState(undefined);

    const [loading, setLoading] = useState(false);

    // 计算信息完善度
    const calculateCompleteness = item => {
        const orgType = item.orgType;
        let requiredFields = [];

        // 根据机构类型定义必要字段
        switch (orgType) {
            case 1: // 医疗机构
                requiredFields = ['logo', 'introduction', 'establishedAt', 'medType', 'medOwnership', 'medTier', 'medLevel', 'medGrade', 'baiduBaikeUrl', 'bedCount', 'employeeCount', 'annualOutpatientEmergVisits', 'provinceCode', 'address', 'postCode', 'fax', 'email', 'tel', 'site'];
                break;
            case 2: // 企业
                requiredFields = ['logo', 'introduction', 'establishedAt', 'baiduBaikeUrl', 'legalRep', 'bizScope', 'provinceCode', 'address', 'postCode', 'fax', 'email', 'tel', 'site'];
                break;
            case 3: // 学协会
                requiredFields = ['logo', 'introduction', 'establishedAt', 'baiduBaikeUrl', 'provinceCode', 'address', 'postCode', 'fax', 'email', 'tel', 'site'];
                break;
            case 4: // 科研院校
                requiredFields = ['logo', 'introduction', 'establishedAt', 'baiduBaikeUrl', 'provinceCode', 'address', 'postCode', 'fax', 'email', 'tel', 'site'];
                break;
            case 5: // 政府
                requiredFields = ['logo', 'introduction', 'baiduBaikeUrl', 'provinceCode', 'address', 'postCode', 'fax', 'email', 'tel', 'site'];
                break;
            case 0: // 未分类
            default:
                requiredFields = ['logo', 'introduction', 'baiduBaikeUrl', 'provinceCode', 'address', 'postCode', 'fax', 'email', 'tel', 'site'];
                break;
        }

        // 计算有值字段数
        const filledFields = requiredFields.filter(field => {
            // 处理字段名映射
            let actualField = field;
            if (field === 'provinceCode') {
                actualField = item.provinceCode !== undefined ? 'provinceCode' : 'province_code';
            }

            const value = item[actualField];
            return value !== null && value !== undefined && value !== '' && value !== 0;
        });

        // 计算完善度百分比
        const completeness = Math.round((filledFields.length / requiredFields.length) * 100);
        return completeness;
    };

    const onRadioChange = e => {
        console.log('radio checked', e.target.value);
        setValue(e.target.value);
    };

    // 处理Radio选择，确保只有已勾选的机构才能设为主机构
    const handleRadioChange = itemId => {
        // 只有当机构被勾选时才能设为主机构
        if (checkedList.includes(itemId)) {
            setValue(itemId);
        }
    };

    // 查看机构
    const handleView = record => {
        setOpenViewOrgDrawer(true);
        setCurrentRecordId(record.id);
    };

    const onCheckChange = list => {
        setCheckedList(list);
        setIndeterminate(!!list.length && list.length < searchHospitalList.length);
        setCheckAll(list.length === searchHospitalList.length);

        // 如果当前选择的主机构不在新的勾选列表中，清除主机构选择
        if (value && !list.includes(value)) {
            setValue(undefined);
        }
    };
    const onCheckAllChange = e => {
        const newCheckedList = e.target.checked ? searchHospitalList.map(item => item.id) : [];
        setCheckedList(newCheckedList);
        setIndeterminate(false);
        setCheckAll(e.target.checked);

        // 如果取消全选，清除主机构选择
        if (!e.target.checked) {
            setValue(undefined);
        }
    };

    // 合并机构
    const onMerge = () => {
        Modal.confirm({
            title: '确认合并',
            icon: <i className="bi bi-exclamation-circle"></i>,
            centered: true,
            content: <Text type="danger">机构合并后，被合并机构将不可见，接入机构库的各业务系统将统一展示为主机构，确认合并？</Text>,
            okText: '确定',
            onOk: async () => {
                try {
                    const mergedOrgIds = checkedList && !!checkedList.length && checkedList.filter(item => item !== value); // 过滤掉主机构本身ID
                    const res = await mergeOrganizationsApi({
                        id: value,
                        idList: mergedOrgIds,
                    });
                    if (res.status_code === 200) {
                        message.success('机构合并成功');

                        // 跳转到机构列表
                        navigate('/dc/organization/list');

                        // 上报操作日志
                        try {
                            // 获取被合并机构的详细信息用于日志记录
                            const mergedOrgs = searchHospitalList.filter(org => mergedOrgIds.includes(org.id));
                            await logOrganizationMerge(value, mergedOrgs);
                        } catch (logError) {
                            console.error('操作日志上报失败', logError);
                            // 日志上报失败不影响主流程
                        }
                    }
                } catch (error) {
                    console.error('机构合并失败', error);
                    message.error('机构合并失败');
                }
            },
            cancelText: '取消',
        });
    };

    const onSearch = async () => {
        form.validateFields().then(async values => {
            const newValues = { ...values };

            console.log('values', values);
            if (values.keywordList) {
                newValues.keywordList = values.keywordList.split(',') || [];
            }

            // orgType 如果没有未分类，则添加未分类
            if (values.orgType && Array.isArray(values.orgType)) {
                newValues.orgType = [...values.orgType];
                if (!newValues.orgType.includes(0)) {
                    newValues.orgType.push(0);
                }
            } else {
                // 如果没有选择机构类型，默认包含未分类
                newValues.orgType = [0];
            }

            const apiParams = { ...newValues, page: 1, size: 100 };
            const res = await organizationsListApi(apiParams);
            if (res && res.status_code === 200 && res.data) {
                setSearchHospitalList(res.data.records || []);
                setHasSearched(true); // 标记已执行检索
                if (res.data.records && res.data.records.length > 1) {
                    setCurrentStep(1); // 如果检索到多个机构，进入合并步骤
                }
            }
        });
    };

    // 列表携带合并信息——回显
    useEffect(() => {
        if (location.state?.orgType && location.state?.keyword) {
            form.setFieldValue(['orgType', 0], location.state.orgType);
            form.setFieldValue('keywordList', location.state.keyword);

            const params = {
                orgType: [location.state.orgType],
                keywordList: location.state.keyword?.split(',') || [],
                page: 1,
                size: 100, // 合并时最多检索100个机构
            };
            // orgType 如果没有未分类，则添加未分类
            if (!params.orgType.includes(0)) {
                params.orgType.push(0);
            }
            setLoading(true);
            organizationsListApi(params).then(res => {
                setLoading(false);
                if (res && res.status_code === 200 && res.data) {
                    setSearchHospitalList(res.data.records || []);
                    setHasSearched(true); // 标记已执行检索
                    if (res.data.records && res.data.records.length > 1) {
                        setCurrentStep(1); // 如果检索到多个机构，进入合并步骤
                    }
                }
            });
        }
    }, [form, location.state]);

    // 步骤配置
    const steps = [
        { title: '检索机构', description: '检索要合并的机构' },
        { title: '机构合并', description: '选择主机构并确认合并' },
    ];

    // 返回第一步
    const goToFirstStep = () => {
        setCurrentStep(0);
        setCheckedList([]);
        setValue(undefined);
        // 不清空搜索结果，保持hasSearched状态，让用户能看到检索结果
    };

    // 渲染检索机构步骤
    const renderSearchStep = () => (
        <>
            <div className="step-title">
                <h3>检索机构</h3>
                <p>请输入机构类型和关键字来检索相关机构</p>
            </div>

            <Form form={form} labelCol={{ sm: { span: 6 }, lg: { span: 6 }, xl: { span: 6 }, xxl: { span: 8 } }} wrapperCol={{ sm: { span: 18 }, lg: { span: 16 }, xl: { span: 14 }, xxl: { span: 10 } }} layout="horizontal">
                <Form.Item label="机构类型" name={['orgType', 0]} rules={[{ required: true, message: '请选择机构类型' }]} extra="请选择要合并机构的类型。仅支持同类型机构或未分类机构之间的合并。" className="organization-form-item">
                    <Select placeholder="选择机构类型" allowClear>
                        {orgTypeList
                            && !!orgTypeList.length
                            && orgTypeList.map((item, index) => (
                                <Select.Option key={index} value={item.value}>
                                    {item.label}
                                </Select.Option>
                            ))}
                    </Select>
                </Form.Item>

                <Form.Item label="关键字" name="keywordList" rules={[{ required: true, message: '请输入机构名称关键字' }]} extra="多个名称关键字或 ID 用英文逗号隔开">
                    <Input placeholder="输入机构名称关键字" allowClear />
                </Form.Item>

                <Form.Item wrapperCol={{ sm: { span: 18, offset: 6 }, lg: { span: 16, offset: 6 }, xl: { span: 14, offset: 6 }, xxl: { span: 10, offset: 8 } }}>
                    <Button type="primary" onClick={onSearch}>
                        检索机构
                    </Button>
                </Form.Item>
            </Form>

            <Row justify="center">
                <Col sm={24} lg={20} xl={16} xxl={12}>
                    {hasSearched && searchHospitalList && searchHospitalList.length === 0 && <Alert title="未检索到相关医疗机构" type="warning" />}

                    {hasSearched && searchHospitalList && searchHospitalList.length === 1 && (
                        <>
                            <Alert title="仅查询到1个符合条件的机构，无须合并" type="warning" />

                            <div className="organization-list-box">
                                <div className="organization-list-header">
                                    <div className="field-item name">机构名称</div>
                                    <div className="field-item type">机构类型</div>
                                    <div className="field-item status">审核状态</div>
                                    <div className="field-item completeness">信息完善度</div>
                                </div>
                                <div className="organization-list-body">
                                    {searchHospitalList
                                        && searchHospitalList.map((item, index) => (
                                            <div className="organization-list-item" key={index}>
                                                <div className="field-item name">
                                                    <span className="organization-name">{item.name}</span>
                                                    <span className="organization-id">#{item.id}</span>
                                                </div>
                                                <div className="field-item type">{orgTypeList.find(org => org.value === item.orgType)?.label}</div>
                                                <div className="field-item status">{item?.reviewStatus !== undefined && <Text type={ReviewStatusMap[item.reviewStatus]?.type}>{ReviewStatusMap[item.reviewStatus]?.text}</Text>}</div>
                                                <div className={`field-item completeness ${calculateCompleteness(item) >= 80 ? 'completeness-high' : ''}`}>{calculateCompleteness(item)}%</div>
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </>
                    )}
                </Col>
            </Row>
        </>
    );

    // 渲染机构合并步骤
    const renderMergeStep = () => (
        <>
            <div className="step-title">
                <h3>机构合并</h3>
                <p>选择要合并的机构并指定主机构</p>
            </div>

            <Row justify="center">
                <Col sm={24} xxl={20}>
                    <Alert
                        title={
                            <div className="tips-box">
                                <p>请选择要合并的机构，并设定“主机构”。确认无误后，点击“确认合并”。</p>
                                <p>
                                    <b>注意：</b>被合并的机构将无法再管理。
                                </p>
                                <p>接入机构库的相关功能，检索被合并机构会返回对应的“主机构”。</p>
                            </div>
                        }
                        type="warning"
                    />

                    {/* 大于5条时，为方便操作，表格上方也添加操作项 */}
                    {searchHospitalList && searchHospitalList.length >= 5 && (
                        <>
                            <Space>
                                <Button
                                    onClick={goToFirstStep}
                                    icon={
                                        <span className="anticon">
                                            <i className="bi bi-arrow-left"></i>
                                        </span>
                                    }
                                >
                                    重新检索
                                </Button>
                                <Button type="primary" onClick={onMerge} disabled={!value || checkedList.length < 2}>
                                    确认合并
                                </Button>
                            </Space>
                        </>
                    )}

                    <div className="organization-list-box">
                        <div className="organization-list-header">
                            <div className="field-item name">
                                <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}>
                                    <span>机构名称</span>
                                </Checkbox>
                            </div>
                            <div className="field-item type">机构类型</div>
                            <div className="field-item status">审核状态</div>
                            <div className="field-item completeness">信息完善度</div>
                            <div className="field-item operation">操作</div>
                        </div>
                        <div className="organization-list-body">
                            <Radio.Group onChange={onRadioChange} value={value}>
                                {searchHospitalList
                                    && searchHospitalList.map((item, index) => (
                                        <div className="organization-list-item" key={index}>
                                            <div className="field-item name">
                                                <Checkbox
                                                    checked={checkedList.includes(item.id)}
                                                    onChange={e => {
                                                        const next = e.target.checked ? [...checkedList, item.id] : checkedList.filter(id => id !== item.id);
                                                        onCheckChange(next);
                                                    }}
                                                >
                                                    <span className="organization-name">{item.name}</span>
                                                    <span className="organization-id">#{item.id}</span>
                                                </Checkbox>
                                            </div>
                                            <div className="field-item type">{orgTypeList.find(org => org.value === item.orgType)?.label}</div>
                                            <div className="field-item status">{item?.reviewStatus !== undefined && <Text type={ReviewStatusMap[item.reviewStatus]?.type}>{ReviewStatusMap[item.reviewStatus]?.text}</Text>}</div>
                                            <div className={`field-item completeness ${calculateCompleteness(item) >= 80 ? 'completeness-high' : ''}`}>{calculateCompleteness(item)}%</div>
                                            <div className="field-item operation">
                                                <Radio value={item.id} disabled={!checkedList.includes(item.id)} onClick={() => handleRadioChange(item.id)}>
                                                    主机构（保留）
                                                </Radio>
                                                <Divider orientation="vertical" />
                                                <Button type="link" size="small" onClick={() => handleView(item)}>
                                                    查看
                                                </Button>
                                            </div>
                                        </div>
                                    ))}
                            </Radio.Group>
                        </div>
                    </div>

                    <Space style={{ marginTop: 16 }}>
                        <Button
                            onClick={goToFirstStep}
                            icon={
                                <span className="anticon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                                    </svg>
                                </span>
                            }
                        >
                            重新检索
                        </Button>
                        <Button type="primary" onClick={onMerge} disabled={!value || checkedList.length < 2}>
                            确认合并
                        </Button>
                    </Space>
                </Col>
            </Row>
        </>
    );

    const goBack = () => {
        // 返回上一页，如果是新打开页面，则返回合并机构管理列表
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate('/dc/organization/merge-list');
        }
    };

    useEffect(() => {
        document.title = '合并机构-机构库';
    }, []);

    return (
        <>
            <PageHeader
                title={
                    <>
                        <i className="bi bi-chevron-left page-header-back-btn" onClick={() => goBack()} />
                        <span>合并机构</span>
                    </>
                }
                breadcrumb={[{ label: '数据中心' }, { label: '机构库' }, { label: '合并机构管理', path: '/dc/organization/merge-list' }, { label: '合并机构' }]}
            />

            <div className="page-route-body organization-merge">
                <div className="steps-container">
                    <Steps current={currentStep} items={steps} />
                </div>
                {!loading && (
                    <div className="steps-content">
                        {currentStep === 0 && renderSearchStep()}
                        {currentStep === 1 && renderMergeStep()}
                    </div>
                )}
                {loading && (
                    <div className="steps-content loading">
                        <Spin size="large" />
                    </div>
                )}
            </div>

            <ViewOrgDrawer
                openViewOrgDrawer={openViewOrgDrawer}
                setOpenViewOrgDrawer={setOpenViewOrgDrawer}
                id={currentRecordId}
                setCurrentRecordId={setCurrentRecordId}
                setOpenAddOrgDrawer={() => {}} // 在合并页面不需要编辑功能，传空函数
                showEditButton={false} // 在合并页面不显示编辑按钮
            />
        </>
    );
};

export default OrganizationMerge;
